import { Link, useNavigate } from "react-router-dom";
import { BUTTON_STYLE } from "../../assets/constants";
import Boxcontainer from "../../components/admin/BoxCotainer";
import { useLayoutEffect } from "react";

export default function AdminHome() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  useLayoutEffect(() => {
    if (user.role !== "ADMIN") {
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }
  }, []);
  return (
    <>
      <Boxcontainer />
      <div className="grid gird-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <Link
          to={window.location.pathname + "add-assesment"}
          className={`${BUTTON_STYLE} font-semibold text-lg p-5`}
        >
          Add Mark
        </Link>

        <Link
          to={window.location.pathname + "update-assesment"}
          className={`${BUTTON_STYLE}  font-semibold text-lg p-5`}
        >
          Update Mark
        </Link>
        <Link
          to={window.location.pathname + "new-announcement"}
          className={`${BUTTON_STYLE} md:col-span-2 lg:col-span-1  font-semibold text-lg p-5`}
        >
          New Announcement
        </Link>
      </div>
    </>
  );
}
